import React from "react";
import { RemontPage } from "../index";

export const SingleRemont = () => {
  return <RemontPage isSingleRemont={true} />;
};
